module.exports = __webpack_public_path__ + "static/media/camera-icon.8d494881.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/camera-icon.png
// module id = 1719
// module chunks = 0